module.exports = __webpack_public_path__ + "media/components/Giftaid/static/giftaid-94a6f17cdffa6ca020b94b815065b93f.svg";